import React from "react";
import { PickersDay, Badge } from "investira.react.components";

function ServerDay(props) {
  const {
    highlightedDays = [],
    onlyHighlightAble = false,
    day,
    outsideCurrentMonth = false,
    ...other
  } = props;

  const isHighlighted =
    !outsideCurrentMonth && highlightedDays.indexOf(day.date()) >= 0;

  const xPickersDayProps = {
    ...other,
    outsideCurrentMonth,
    day,
    ...(onlyHighlightAble && { disabled: !isHighlighted }),
  };

  return (
    <Badge
      key={props.day.toString()}
      color={isHighlighted ? "warning" : ""}
      overlap="circular"
      variant="dot"
    >
      <PickersDay {...xPickersDayProps} />
    </Badge>
  );
}

ServerDay.displayName = "ServerDay";

export default ServerDay;
